/// <amd-module name="VSSUI/Components/StackPanel/StackPanel" />
import * as React from "react";
import { css } from "VSSUI/Util";
import { Button } from "VSSUI/Button";
import { IStackPanelProps, IStackPanelItem, IStackPanel } from "./StackPanel.Props";

const backIconProps = { iconName: "ChevronLeft", className: "vss-StackPanel-BackIcon" };

interface IStackPanelState {
    stack: IStackPanelItem[];
}

export class StackPanel extends React.Component<IStackPanelProps, IStackPanelState> implements IStackPanel {
    constructor(props: IStackPanelProps) {
        super(props);

        this.state = {
            stack: props.initialStack || []
        };
    }

    public render() {
        const { stack } = this.state;
        const topElement = this.peek();

        return (
            <div className={css("vss-StackPanel flex-column", this.props.className, topElement.className)}>
                {topElement.title && (
                    <div className={"vss-StackPanel-Header flex-row"}>
                        {stack.length > 1 && (
                            <Button subtle={true} onClick={this.pop.bind(this)} className={"vss-StackPanel-BackButton"} iconProps={backIconProps} />
                        )}
                        <div className={"vss-StackPanel-Title title-xs"}>{topElement && topElement.title}</div>
                    </div>
                )}
                {topElement && topElement.renderContent && topElement.renderContent()}
            </div>
        );
    }

    public push(item: IStackPanelItem): void {
        const { stack } = this.state;
        stack.push(item);

        this.setState({
            stack: stack
        });
    }

    public pop(): IStackPanelItem {
        const { stack } = this.state;
        const poppedItem = stack.pop();

        this.setState({
            stack: stack
        });

        if (poppedItem.onPop) {
            poppedItem.onPop();
        }

        return poppedItem;
    }

    public peek(): IStackPanelItem {
        return this.state.stack[this.state.stack.length - 1];
    }
}
